/**
 * @generated SignedSource<<6ea3acabab9a36a2baa6165fea5b15ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetSlackUserIdOnImportMemberInput = {
  id: string;
  mappedUserId?: string | null;
};
export type SlackUserDropdownListMutation$variables = {
  input: SetSlackUserIdOnImportMemberInput;
};
export type SlackUserDropdownListMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly isFuzzyMatch: boolean;
      readonly mappedSlackUser: {
        readonly " $fragmentSpreads": FragmentRefs<"SlackUserAvatarWithEmailFragment">;
      } | null;
    } | null;
  };
};
export type SlackUserDropdownListMutation = {
  response: SlackUserDropdownListMutation$data;
  variables: SlackUserDropdownListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFuzzyMatch",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackUserDropdownListMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "SetSlackUserIdOnImportMemberResponse",
        "kind": "LinkedField",
        "name": "setSlackUserIdOnImportMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlackUserImportMember",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackUserImportMember",
                "kind": "LinkedField",
                "name": "mappedSlackUser",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SlackUserAvatarWithEmailFragment"
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackUserDropdownListMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "SetSlackUserIdOnImportMemberResponse",
        "kind": "LinkedField",
        "name": "setSlackUserIdOnImportMember",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlackUserImportMember",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackUserImportMember",
                "kind": "LinkedField",
                "name": "mappedSlackUser",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slackUserIconUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "589ea90cc7412dda462f12dc2a4ad4b7",
    "id": null,
    "metadata": {},
    "name": "SlackUserDropdownListMutation",
    "operationKind": "mutation",
    "text": "mutation SlackUserDropdownListMutation(\n  $input: SetSlackUserIdOnImportMemberInput!\n) {\n  response: setSlackUserIdOnImportMember(input: $input) {\n    node {\n      id\n      mappedSlackUser {\n        ...SlackUserAvatarWithEmailFragment\n        id\n      }\n      isFuzzyMatch\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment SlackUserAvatarWithEmailFragment on SlackUserImportMember {\n  id\n  firstName\n  lastName\n  fullName\n  email\n  slackUserIconUrl\n}\n"
  }
};
})();

(node as any).hash = "f9cd6aab66804f11944e07de550a0885";

export default node;
